import {useState} from "preact/compat";

export const useInitialSteps = (props) => {
    // Destructured props
    const {
        surveyData,
        handleStepChange,
        handlePayloadUpdate
    } = props;

    // State to store all user's answers
    const [formValues, setFormValues] = useState({
        overallRating: undefined,
        selectedOptions: []
    });

    // Procedure to handle all input changes
    const handleChange = (props) => {
        // Destructured props
        const {
            target,
            event,
            optionId = null
        } = props;

        // Assigns the values into the formValues state object
        // according to the "target" property
        switch (target.toUpperCase()) {
            case "RATING": {
                // Proceeds to the next step when a value is selected
                if (!formValues.overallRating) {
                    handleStepChange({
                        action: "NEXT"
                    });
                }

                setFormValues(prevState => {
                    return {
                        ...prevState,
                        overallRating: parseInt(event.target.value, 10)
                    }
                })

                break;
            }
            case "OPTIONS": {
                let clone;

                // Logic to uncheck the option if it was previously selected
                if (formValues.selectedOptions.includes(optionId)) {
                    clone = [...formValues.selectedOptions];
                    let itemIndex = clone.indexOf(optionId);

                    clone.splice(itemIndex, 1);
                }

                setFormValues(prevState => {
                    return {
                        ...prevState,
                        selectedOptions: clone || [
                            ...prevState.selectedOptions,
                            optionId
                        ],
                    }
                })

                break;
            }
            default:
                return;
        }
    }

    // Procedure to handle the form submission
    const handleSubmit = (e) => {
        // Prevents page from reloading
        e.preventDefault();

        // Basic validation for when no rating was given
        if (!formValues.overallRating) {
            return;
        }

        // Array to store all selected options' labels
        const labels = [];

        // The list in which the iterator should be run through
        const targetList = surveyData[formValues.overallRating < 5 ? "improvableOptions" : "enjoyableOptions"];

        // Looks for the label of each selected option
        targetList.forEach(item => {
            formValues.selectedOptions.forEach(subItem => {
                if (subItem === item.id) {
                    labels.push(item.label);
                }
            })
        })

        // Synchronizes the payload state with the current step's form values
        handlePayloadUpdate({
            data: {
                question_text: "Em uma escala de 1 a 5, como foi sua experiência ao realizar compras em nossa Loja Virtual?",
                question_type: "likert",
                rating: formValues.overallRating,
                question_tags: [...labels]
            }
        });

        // Proceeds to the next form step
        handleStepChange({
            action: "NEXT"
        })
    }

    return {
        formValues,
        handleChange,
        handleSubmit,
    }
}
